import './Pagination.scss'

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  onPrevPage,
  onNextPage,
  onFirstPage,
  onLastPage,
  hasNextPage,
  hasPrevPage,
  showFirstLast = true,
  maxPageButtons = 5,
}) => {
  // Generate page numbers to display
  const getPageNumbers = () => {
    const pages = []
    const halfRange = Math.floor(maxPageButtons / 2)

    let startPage = Math.max(1, currentPage - halfRange)
    let endPage = Math.min(totalPages, currentPage + halfRange)

    // Adjust if we're near the start
    if (currentPage <= halfRange) {
      endPage = Math.min(maxPageButtons, totalPages)
    }

    // Adjust if we're near the end
    if (currentPage + halfRange >= totalPages) {
      startPage = Math.max(1, totalPages - maxPageButtons + 1)
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i)
    }

    return pages
  }

  const pageNumbers = getPageNumbers()

  if (totalPages <= 1) return null

  return (
    <div className="pagination-container dFlex aiCenter jcCenter">
      <div className="pagination dFlex aiCenter">
        {/* First Page Button */}
        {showFirstLast && (
          <button
            className="pagination-btn pagination-first"
            onClick={onFirstPage}
            disabled={!hasPrevPage}
            title="First Page"
          >
            «
          </button>
        )}

        {/* Previous Page Button */}
        <button
          className="pagination-btn pagination-prev"
          onClick={onPrevPage}
          disabled={!hasPrevPage}
          title="Previous Page"
        >
          ‹
        </button>

        {/* Page Numbers */}
        <div className="pagination-pages dFlex aiCenter">
          {/* Show first page if not in range */}
          {pageNumbers[0] > 1 && (
            <>
              <button
                className="pagination-btn pagination-number"
                onClick={() => onPageChange(1)}
              >
                1
              </button>
              {pageNumbers[0] > 2 && (
                <span className="pagination-ellipsis">...</span>
              )}
            </>
          )}

          {/* Page Number Buttons */}
          {pageNumbers.map((pageNum) => (
            <button
              key={pageNum}
              className={`pagination-btn pagination-number ${
                pageNum === currentPage ? 'active' : ''
              }`}
              onClick={() => onPageChange(pageNum)}
            >
              {pageNum}
            </button>
          ))}

          {/* Show last page if not in range */}
          {pageNumbers[pageNumbers.length - 1] < totalPages && (
            <>
              {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && (
                <span className="pagination-ellipsis">...</span>
              )}
              <button
                className="pagination-btn pagination-number"
                onClick={() => onPageChange(totalPages)}
              >
                {totalPages}
              </button>
            </>
          )}
        </div>

        {/* Next Page Button */}
        <button
          className="pagination-btn pagination-next"
          onClick={onNextPage}
          disabled={!hasNextPage}
          title="Next Page"
        >
          ›
        </button>

        {/* Last Page Button */}
        {showFirstLast && (
          <button
            className="pagination-btn pagination-last"
            onClick={onLastPage}
            disabled={!hasNextPage}
            title="Last Page"
          >
            »
          </button>
        )}
      </div>

      {/* Page Info */}
      <div className="pagination-info ml-3">
        Page {currentPage} of {totalPages}
      </div>
    </div>
  )
}

export default Pagination
